"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var WirelessCart_1 = require("./WirelessCart");
exports.default = WirelessCart_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/WirelessCart/index.js
// module id = 139
// module chunks = 8